import axiosInstance from './axiosConfig';

/**
 * Get FAQs marked for home page display
 * @returns {Promise} Response with grouped FAQs data
 */
export const getHomeFaqs = async () => {
  const response = await axiosInstance.get('/laptops/faqs/home');
  return response.data;
};
/**
 * Get all active FAQs grouped by topic
 * @returns {Promise} Response with grouped FAQs data
 */
export const getAllFaqsGrouped = async () => {
  const response = await axiosInstance.get('/laptops/faqs/grouped');
  return response.data;
};
